import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col justify-center items-center py-20 px-4 bg-neutral-950 overflow-hidden" data-id="element-17">
      {/* Background Ambience */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-neutral-900 via-neutral-950 to-black opacity-80" data-id="element-18" />

      <div className="relative z-10 max-w-3xl mx-auto w-full flex flex-col items-center text-center" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-8" data-id="element-20">
          <p className="text-neutral-400 text-lg md:text-xl font-medium mb-6 italic" data-id="element-21">
            Hay una versión de ti que ya está cansada de fingir.
          </p>

          <div className="space-y-2 text-neutral-300 text-lg leading-relaxed max-w-xl mx-auto" data-id="element-22">
            <p data-id="element-23">La que se levanta… se baña… maneja… entra…</p>
            <p data-id="element-24">y actúa como si nada,</p>
            <p data-id="element-25">cuando por dentro lo único que piensa es:</p>
          </div>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="text-4xl md:text-6xl font-black text-white uppercase tracking-tighter leading-none mb-8" data-id="element-26">
          “No puedo renunciar… <br data-id="element-27" />
          <span className="text-red-600 relative inline-block" data-id="element-28">
            pero no aguanto más
            <motion.span initial={{
            width: 0
          }} animate={{
            width: '100%'
          }} transition={{
            delay: 1,
            duration: 0.8
          }} className="absolute bottom-1 left-0 h-1 bg-red-600 w-full" data-id="element-29" />
          </span>
          .”
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.8,
        duration: 0.8
      }} className="mb-12" data-id="element-30">
          <div className="relative group cursor-pointer" data-id="element-31">
            <div className="absolute -inset-1 bg-red-600 rounded-lg blur opacity-20 group-hover:opacity-40 transition duration-1000 group-hover:duration-200" data-id="element-32"></div>
            <img src="https://cdn.magicpatterns.com/uploads/iedMqhHY8M1TZM68mwJeyn/planm_de_sa.png" alt="No Puedo Renunciar - Plan de Supervivencia" className="relative w-64 md:w-80 rounded-lg shadow-2xl transform rotate-1 hover:rotate-0 transition-transform duration-500 border border-neutral-800" data-id="element-33" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.2,
        duration: 0.8
      }} className="text-left md:text-center max-w-xl text-neutral-400 mb-10 space-y-4" data-id="element-34">
          <p data-id="element-35">Y lo peor no es el trabajo.</p>
          <p data-id="element-36">
            Lo peor es lo que te está haciendo{' '}
            <strong className="text-white" data-id="element-37">después</strong> del trabajo:
          </p>
          <ul className="text-left space-y-2 pl-4 border-l-2 border-red-900/50 ml-4 md:ml-0 md:border-none md:pl-0" data-id="element-38">
            <li className="flex items-center md:justify-center gap-2" data-id="element-39">
              <span className="w-1.5 h-1.5 bg-red-600 rounded-full md:hidden" data-id="element-40"></span>
              llegas sin energía para tu vida real
            </li>
            <li className="flex items-center md:justify-center gap-2" data-id="element-41">
              <span className="w-1.5 h-1.5 bg-red-600 rounded-full md:hidden" data-id="element-42"></span>
              te vuelves más frío o más explosivo
            </li>
            <li className="flex items-center md:justify-center gap-2" data-id="element-43">
              <span className="w-1.5 h-1.5 bg-red-600 rounded-full md:hidden" data-id="element-44"></span>
              el domingo te pesa como una amenaza
            </li>
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.5
      }} data-id="element-45">
          <Button size="xl" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-46">
            QUIERO EL PLAN DE SUPERVIVENCIA
          </Button>
          <p className="mt-4 text-sm text-neutral-500" data-id="element-47">
            Descarga inmediata • PDF + Workbook
          </p>
        </motion.div>
      </div>
    </section>;
}